"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectDefinition = void 0;
const firestore_1 = require("comodel/firestore");
exports.projectDefinition = (0, firestore_1.defineCollection)({
    collectionName: "scenario_project",
    idKey: "projectId",
    constraints: ["projectId"],
    queryDefs: {
        list: ({ projectIds, condition, }) => {
            return {
                queryParams: projectIds
                    ? {
                        filter: { projectId: { $in: projectIds } },
                    }
                    : {
                        orderBy: [["createdAt", "desc"]],
                    },
                filterParams: condition,
            };
        },
    },
    defaultValue: {},
    onGenerate: (o) => (Object.assign(Object.assign({}, o), { createdAt: Date.now() })),
    onWrite: (o) => (Object.assign(Object.assign({}, o), { updatedAt: Date.now() })),
});
